export const setstylist = (p) => {
  return {
    type: "SET_STYLIST_DETAILS",
    payload: p,
  };
};
